<div class="services-grid">
  <div *ngFor="let item of allServices"
       class="service-chip"
       [class.service-chip--included]="item.included"
       [class.service-chip--excluded]="!item.included">
    <i class="ti ti-{{item.icon}} service-icon"></i>
    <span class="service-label">{{ item.label }}</span>
    <i class="ti service-status"
       [class.ti-circle-check]="item.included"
       [class.ti-circle-x]="!item.included"></i>
  </div>
</div>
